import TennisGame from "../../sports/tennis/tennis-game";
import * as TiebreakType from "../../sports/tennis/enums/tiebreak-type";
import * as MatchTiebreakType from "../../sports/tennis/enums/match-tiebreak-type";
import * as GameType from "../../sports/tennis/enums/game-type";
import IncompleteType from "../../sports/tennis/enums/incomplete-type";
import TennisTeamSide from "../../sports/tennis/enums/tennis-team-side";
import SetType from "../../sports/tennis/enums/set-type";
import MatchResultType from "../../sports/tennis/enums/match-result-type";
import {
    getGameType,
    getMatchResult,
    getMaxGamesPerSet,
    getMaxTieBreakPoints,
    getSetWinner,
    isMatchTied,
    isSetComplete,
    isSetTiebreakEligible,
    getTiebreakAdjustedSet,
    isSetDisabled,
    getAdditionalGames
} from "../../sports/tennis/utils/tennis-utils";

export default {
    TennisGame,
    TiebreakType,
    MatchTiebreakType,
    GameType,
    IncompleteType,
    TennisTeamSide,
    SetType,
    MatchResultType,
    getMaxGamesPerSet,
    getMaxTieBreakPoints,
    getGameType,
    getSetWinner,
    isMatchTied,
    isSetComplete,
    getMatchResult,
    isSetTiebreakEligible,
    getTiebreakAdjustedSet,
    isSetDisabled,
    getAdditionalGames
};
